import React from 'react';
import { Link } from 'react-router-dom';

import { Card, Heading, PageContainer, Section } from '../../../shared/ui';

const ContentSection = ({ title, paragraphs = [], cards = [] }) => {
  return (
    <Section>
      <PageContainer>
        <div className="yowan-content-section">
          {title ? <Heading as="h2">{title}</Heading> : null}
          <div className="yowan-content-section__body u-stack-md">
            {paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
          {cards.length ? (
            <div className="yowan-content-section__cards">
              {cards.map((card) => (
                <Card key={card.title} className="yowan-content-section__card">
                  <Heading as="h3">{card.title}</Heading>
                  {card.meta ? <p className="yowan-content-section__meta">{card.meta}</p> : null}
                  <p>{card.body}</p>
                  {card.href ? (
                    card.external ? (
                      <a
                        className="yowan-content-section__card-link"
                        href={card.href}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {card.ctaLabel || '詳しく見る'}
                      </a>
                    ) : (
                      <Link className="yowan-content-section__card-link" to={card.href}>
                        {card.ctaLabel || '詳しく見る'}
                      </Link>
                    )
                  ) : null}
                </Card>
              ))}
            </div>
          ) : null}
        </div>
      </PageContainer>
    </Section>
  );
};

export default ContentSection;
